import React from 'react';

const Info: React.FC = () => {
  return (
    <>
      <div className="page-eyebrow">
        How this works
      </div>
      <div className="wa-stack wa-gap-xs">
        <div className="wa-cluster">
          <div>
            <wa-avatar initials="1" style={{ '--size': '20px' }} />
          </div>
          <div>
            Upload all your photos — we read the date from each file automatically.
          </div>
        </div>
        <div className="wa-cluster">
          <div>
            <wa-avatar initials="2" style={{ '--size': '20px' }} />
          </div>
          <div>
            Photos taken close together are grouped. Photos far apart become separate memories.
          </div>
        </div>
        <div className="wa-cluster">
          <div>
            <wa-avatar initials="3" style={{ '--size': '20px' }} />
          </div>
          <div>
            Name each group, add a sentence or two, and publish the whole timeline at once.
          </div>
        </div>
      </div>
    </>
  );
}

export default Info;
